<script>
  import { onMount } from 'svelte'
  import { transactionStore, dataStore } from '../../stores'
  import Loader from '../Loader.svelte'
  import AddTransactionsModal from './AddTransactionsModal.svelte'
  import EditTransactionModal from './EditTransactionModal.svelte'
  import { Datatable } from 'svelte-simple-datatables'
  import { settings } from '../../../scripts/datatablesSettings'
  import { config } from '../../../scripts/defaultURL'
  import { formatDate, openModal } from '../../../scripts/functions'
  import { getData } from '../../../scripts/rest'
  import { tick } from 'svelte'

  let initialized = false
  let transactionSelected = false
  let transactionsData
  let transaction
  let clientsData
  let clientOptions
  let categoryOptions
  let rows

  $: if ($transactionStore && $transactionStore.todo == 'getData') {
    getData(`${config.defaultURL}/transactions`).then((res) => {
      transactionsData = res
      transactionSelected = false
    })
    $transactionStore.todo = ''
  }

  $: if (transactionsData && clientsData) {
    initialized = true
    if (!$dataStore) $dataStore = {}
    $dataStore['transactions'] = transactionsData
    $dataStore['clients'] = clientsData
    console.log('dataStore', $dataStore)

    genClientsOptions()
    genCategoryOptions()
  }

  function genCategoryOptions() {
    const sorted = transactionsData.sort((a, b) => {
      const A = a.category ? a.category.toUpperCase() : null
      const B = b.category ? b.category.toUpperCase() : null
      if (A < B) return -1
      if (B < A) return 1
      return 0
    })

    categoryOptions = []

    sorted.forEach((item) => {
      if (item.category && categoryOptions.indexOf(item.category) == -1)
        categoryOptions.push(item.category)
    })
  }

  function genClientsOptions() {
    const unique = []
    const sorted = clientsData.sort((a, b) => {
      const A = a.first.toUpperCase()
      const B = b.first.toUpperCase()
      if (A < B) return -1
      if (B < A) return 1
      return 0
    })

    clientOptions = []

    sorted.forEach((item) => {
      if (unique.indexOf(item.id) == -1) {
        unique.push(item.id)
        clientOptions.push(item)
      }
    })
  }

  function getClientName(clientId) {
    const filtered = clientsData.filter((item) => {
      return item.id == clientId
    })

    if (filtered.length) return `${filtered[0].first} ${filtered[0].last}`
    return ''
  }

  async function editTransactionModal(item) {
    transaction = item
    transactionSelected = true

    await tick()
    openModal('editTransactionModal')
  }

  onMount(() => {
    getData(`${config.defaultURL}/transactions`).then((res) => {
      transactionsData = res
    })
    if (!$dataStore || !$dataStore.clients)
      getData(`${config.defaultURL}/clients`).then((res) => {
        clientsData = res
      })
    else clientsData = $dataStore.clients
  })
</script>

<div class="flex">
  <div class="left">
    <h3>Transactions List</h3>
  </div>
  <div class="right">
    <button
      on:click={() => {
        openModal('transactionsModal')
      }}
      class="button is-primary"
    >
      <span class="icon">
        <svg style="width:24px;height:24px" viewBox="0 0 24 24">
          <path
            fill="currentColor"
            d="M20 14H14V20H10V14H4V10H10V4H14V10H20V14Z"
          />
        </svg>
      </span>
      <span>Add Transaction</span>
    </button>
  </div>
</div>
{#if initialized}
  <div class="table-container">
    <Datatable
      {settings}
      data={transactionsData.sort((a, b) => {
        return new Date(b.date) - new Date(a.date)
      })}
      bind:dataRows={rows}
    >
      <thead>
        <tr>
          <th data-key="income_expense">
            <svg style="width:24px;height:24px;color:green;" viewBox="0 0 24 24"
              ><path
                fill="currentColor"
                d="M7,15H9C9,16.08 10.37,17 12,17C13.63,17 15,16.08 15,15C15,13.9 13.96,13.5 11.76,12.97C9.64,12.44 7,11.78 7,9C7,7.21 8.47,5.69 10.5,5.18V3H13.5V5.18C15.53,5.69 17,7.21 17,9H15C15,7.92 13.63,7 12,7C10.37,7 9,7.92 9,9C9,10.1 10.04,10.5 12.24,11.03C14.36,11.56 17,12.22 17,15C17,16.79 15.53,18.31 13.5,18.82V21H10.5V18.82C8.47,18.31 7,16.79 7,15Z"
              /></svg
            ><span class="slash">/</span><svg
              style="width:24px;height:24px;color:red;"
              viewBox="0 0 24 24"
              ><path
                fill="currentColor"
                d="M3,4.27L4.28,3L21,19.72L19.73,21L16.06,17.33C15.44,18 14.54,18.55 13.5,18.82V21H10.5V18.82C8.47,18.31 7,16.79 7,15H9C9,16.08 10.37,17 12,17C13.13,17 14.14,16.56 14.65,15.92L11.68,12.95C9.58,12.42 7,11.75 7,9C7,8.77 7,8.55 7.07,8.34L3,4.27M10.5,5.18V3H13.5V5.18C15.53,5.69 17,7.21 17,9H15C15,7.92 13.63,7 12,7C11.63,7 11.28,7.05 10.95,7.13L9.4,5.58L10.5,5.18Z"
              /></svg
            >
          </th>
          <th data-key="date">Date</th>
          <th data-key="amount">Amount ($)</th>
          <th data-key="description">Description</th>
          <th data-key="category">Category</th>
          <th data-key="client_id">Client</th>
        </tr>
      </thead>
      <tbody>
        {#if rows}
          {#each $rows as item}
            <tr
              id={item.id}
              on:click={() => {
                editTransactionModal(item)
              }}
            >
              <td>
                {#if item.income_expense == 'income'}
                  <svg
                    style="width:24px;height:24px;color:green;"
                    viewBox="0 0 24 24"
                    ><path
                      fill="currentColor"
                      d="M7,15H9C9,16.08 10.37,17 12,17C13.63,17 15,16.08 15,15C15,13.9 13.96,13.5 11.76,12.97C9.64,12.44 7,11.78 7,9C7,7.21 8.47,5.69 10.5,5.18V3H13.5V5.18C15.53,5.69 17,7.21 17,9H15C15,7.92 13.63,7 12,7C10.37,7 9,7.92 9,9C9,10.1 10.04,10.5 12.24,11.03C14.36,11.56 17,12.22 17,15C17,16.79 15.53,18.31 13.5,18.82V21H10.5V18.82C8.47,18.31 7,16.79 7,15Z"
                    /></svg
                  >
                {:else}
                  <svg
                    style="width:24px;height:24px;color:red;"
                    viewBox="0 0 24 24"
                    ><path
                      fill="currentColor"
                      d="M3,4.27L4.28,3L21,19.72L19.73,21L16.06,17.33C15.44,18 14.54,18.55 13.5,18.82V21H10.5V18.82C8.47,18.31 7,16.79 7,15H9C9,16.08 10.37,17 12,17C13.13,17 14.14,16.56 14.65,15.92L11.68,12.95C9.58,12.42 7,11.75 7,9C7,8.77 7,8.55 7.07,8.34L3,4.27M10.5,5.18V3H13.5V5.18C15.53,5.69 17,7.21 17,9H15C15,7.92 13.63,7 12,7C11.63,7 11.28,7.05 10.95,7.13L9.4,5.58L10.5,5.18Z"
                    /></svg
                  >
                {/if}
              </td>
              <td>{formatDate(item.date)}</td>
              <td>{item.amount}</td>
              <td>{item.description}</td>
              <td>{item.category ? item.category : ''}</td>
              <td>{item.client_id ? getClientName(item.client_id) : ''}</td>
            </tr>
          {/each}
        {/if}
      </tbody>
    </Datatable>
  </div>
{:else}
  <!-- Insert loading animation -->
  <Loader />
{/if}

{#if clientOptions && categoryOptions}
  <AddTransactionsModal {clientOptions} {categoryOptions} />
{/if}

{#if transactionSelected && categoryOptions}
  {#key transaction.id}
    <EditTransactionModal {transaction} {categoryOptions} />
  {/key}
{/if}

<style>
  .table-container {
    overflow-y: auto;
    /* height: 65vh; */
  }

  /* .is-hoverable {
    cursor: pointer;
  } */

  .flex {
    display: flex;
    justify-content: space-between;
    padding: 0.5rem;
  }

  .slash {
    position: relative;
    top: -5px;
    font-size: 1.25rem;
  }

  .table-container tbody tr {
    cursor: pointer;
  }
</style>
